import React from "react";
import { Table } from 'react-bootstrap';

const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
})

export default function RelatedDataForm(props) {

    const formatAsPercentage = (value) => {
        if (value === undefined) {
            return ''
        }
        if (value == 0) {
            return '.'
        }
        return Math.round(parseFloat(value) * 100) + '%'
    }

    const formatAsCurrency = (value) => {
        if (value === undefined) {
            return ''
        }
        if (value == 0) {
            return '.'
        }
        return currencyFormatter.format(value)
    }

    return (
        <React.Fragment>
            <h4>Program Courses</h4>
            <Table striped size="sm" responsive="md">
                <thead>
                    <tr>
                        <th></th>
                        <th className="text-center">{props.yearOneData.reviewYear}</th>
                        <th className="text-center">{props.yearTwoData.reviewYear}</th>
                        <th className="text-center">{props.yearThreeData.reviewYear}</th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                        <td>Course List</td>
                        <td className="text-center fw-bold fs-6">
                            { props.yearOneData?.clist &&
                                props.yearOneData.clist.map(function(v) {
                                    return v
                                }).join(', ')
                            }
                        </td>
                        <td className="text-center fw-bold fs-6">
                            { props.yearTwoData?.clist &&
                                props.yearTwoData.clist.map(function(v) {
                                    return v
                                }).join(', ')
                            }
                        </td>
                        <td className="text-center fw-bold fs-6">
                            { props.yearThreeData?.clist &&
                                props.yearThreeData.clist.map(function(v) {
                                    return v
                                }).join(', ')
                            }
                        </td>
                    </tr>
                    <tr>
                        <td>Average class size</td>
                        <td className="text-center">{props.yearOneData.avgClassSize}</td>
                        <td className="text-center">{props.yearTwoData.avgClassSize}</td>
                        <td className="text-center">{props.yearThreeData.avgClassSize}</td>
                    </tr>
                    <tr>
                        <td>Fill Rate</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.fillRate)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.fillRate)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.fillRate)}</td>
                    </tr>
                    <tr>
                        <td>C-pass rate</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.cPass)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.cPass)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.cPass)}</td>
                    </tr>
                    <tr>
                        <td>Withdrawl rate</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.withdrawalRate)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.withdrawalRate)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.withdrawalRate)}</td>
                    </tr>
                    <tr>
                        <td>Average satisfaction</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.avgSatisfaction)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.avgSatisfaction)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.avgSatisfaction)}</td>
                    </tr>
                    <tr>
                        <td>Taught by FT Instructors</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.ftInstrSections)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.ftInstrSections)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.ftInstrSections)}</td>
                    </tr>
                    <tr>
                        <td>Sections online</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.dlSections)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.dlSections)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.dlSections)}</td>
                    </tr>
                    <tr>
                        <td>Courses not offered online</td>
                        <td className="text-center">{props.yearOneData.coursesNotDl}</td>
                        <td className="text-center">{props.yearTwoData.coursesNotDl}</td>
                        <td className="text-center">{props.yearThreeData.coursesNotDl}</td>
                    </tr>
                    <tr>
                        <td>Bottleneck course</td>
                        <td className="text-center">{props.yearOneData.bottleneck}</td>
                        <td className="text-center">{props.yearTwoData.bottleneck}</td>
                        <td className="text-center">{props.yearThreeData.bottleneck}</td>
                    </tr>
                </tbody>
            </Table>

            <h4>Declared Majors</h4>
            <Table striped size="sm">
                <thead>
                    <tr>
                        <th></th>
                        <th className="text-center">{props.yearOneData.reviewYear}</th>
                        <th className="text-center">{props.yearTwoData.reviewYear}</th>
                        <th className="text-center">{props.yearThreeData.reviewYear}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Majors</td>
                        <td className="text-center">{props.yearOneData.declaredMajors}</td>
                        <td className="text-center">{props.yearTwoData.declaredMajors}</td>
                        <td className="text-center">{props.yearThreeData.declaredMajors}</td>
                    </tr>
                    <tr>
                        <td>Majors % POC</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.pocMajors)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.pocMajors)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.pocMajors)}</td>
                    </tr>
                    <tr>
                        <td>Majors % Female</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.femaleMajors)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.femaleMajors)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.femaleMajors)}</td>
                    </tr>
                    <tr>
                        <td>Majors persistence</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.majorsPersist)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.majorsPersist)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.majorsPersist)}</td>
                    </tr>
                    <tr>
                        <td>Majors persist in program</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.majorsPersistInProgram)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.majorsPersistInProgram)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.majorsPersistInProgram)}</td>
                    </tr>
                </tbody>
            </Table>

            <h4>Graduates</h4>
            <Table striped size="sm">
                <thead>
                    <tr>
                        <th></th>
                        <th className="text-center">{props.yearOneData.reviewYear}</th>
                        <th className="text-center">{props.yearTwoData.reviewYear}</th>
                        <th className="text-center">{props.yearThreeData.reviewYear}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Graduates</td>
                        <td className="text-center">{props.yearOneData.graduates}</td>
                        <td className="text-center">{props.yearTwoData.graduates}</td>
                        <td className="text-center">{props.yearThreeData.graduates}</td>
                    </tr>
                    <tr>
                        <td>Grads % POC</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.pocGraduates)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.pocGraduates)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.pocGraduates)}</td>
                    </tr>
                    <tr>
                        <td>Grads % Female</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.femaleGraduates)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.femaleGraduates)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.femaleGraduates)}</td>
                    </tr>
                    <tr>
                        <td>Grads remain at CNM</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.continuingCnm)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.continuingCnm)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.continuingCnm)}</td>
                    </tr>
                    <tr>
                        <td>Grads transfer to 4 yr</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.transfer4Year)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.transfer4Year)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.transfer4Year)}</td>
                    </tr>
                    <tr>
                        <td>Grads employed NM</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.employedInNm)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.employedInNm)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.employedInNm)}</td>
                    </tr>
                    <tr>
                        <td>Grads employed in field</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.employedInField)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.employedInField)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.employedInField)}</td>
                    </tr>
                    <tr>
                        <td>Grads average earnings</td>
                        <td className="text-center">{formatAsCurrency(props.yearOneData.averageEarning)}</td>
                        <td className="text-center">{formatAsCurrency(props.yearTwoData.averageEarning)}</td>
                        <td className="text-center">{formatAsCurrency(props.yearThreeData.averageEarning)}</td>
                    </tr>
                </tbody>
            </Table>

            <h4>Non-Completers</h4>
            <Table striped size="sm">
                <thead>
                    <tr>
                        <th></th>
                        <th className="text-center">{props.yearOneData.reviewYear}</th>
                        <th className="text-center">{props.yearTwoData.reviewYear}</th>
                        <th className="text-center">{props.yearThreeData.reviewYear}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Non-completers</td>
                        <td className="text-center">{props.yearOneData.nonCompleters}</td>
                        <td className="text-center">{props.yearTwoData.nonCompleters}</td>
                        <td className="text-center">{props.yearThreeData.nonCompleters}</td>
                    </tr>
                    <tr>
                        <td>% POC</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.pocNonCompleters)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.pocNonCompleters)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.pocNonCompleters)}</td>
                    </tr>
                    <tr>
                        <td>% Female</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.femaleNonCompleters)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.femaleNonCompleters)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.femaleNonCompleters)}</td>
                    </tr>
                    <tr>
                        <td>% Transfer</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.transferOut)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.transferOut)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.transferOut)}</td>
                    </tr>
                    <tr>
                        <td>% Transfer to 4yr</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.transfer4yrNonCompleter)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.transfer4yrNonCompleter)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.transfer4yrNonCompleter)}</td>
                    </tr>
                    <tr>
                        <td>% Employed NM</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.employedInNmNonCompleter)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.employedInNmNonCompleter)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.employedInNmNonCompleter)}</td>
                    </tr>
                    <tr>
                        <td>% Employed in Field</td>
                        <td className="text-center">{formatAsPercentage(props.yearOneData.employedInFieldNonCompleter)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearTwoData.employedInFieldNonCompleter)}</td>
                        <td className="text-center">{formatAsPercentage(props.yearThreeData.employedInFieldNonCompleter)}</td>
                    </tr>
                    <tr>
                        <td>Average Earnings</td>
                        <td className="text-center">{formatAsCurrency(props.yearOneData.avgEarningNonCompleter)}</td>
                        <td className="text-center">{formatAsCurrency(props.yearTwoData.avgEarningNonCompleter)}</td>
                        <td className="text-center">{formatAsCurrency(props.yearThreeData.avgEarningNonCompleter)}</td>
                    </tr>
                </tbody>
            </Table>
        </React.Fragment>
    )
}